import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-copy-version-dialog',
  templateUrl: 'copy-version-dialog.component.html',
  standalone: false,
})
export class CopyVersionDialogComponent {
  list: any = [];
  version = '';

  constructor(
    public dialogRef: MatDialogRef<CopyVersionDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      list: unknown;
    },
  ) {
    this.list = data.list ?? [];
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submitSelection(): void {
    this.dialogRef.close(this.version);
  }
}
